import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import DialogCanje from "./DialogCanje.container";
import styles from "./styles";

const enhance = compose(withStyles(styles));
export default enhance(DialogCanje);
